/** `watch()` hands out the form's own nested objects: the e-mail is prepared for saving on a copy. */
export const formValuesToSave = <T extends { automatedEmail: object }>(
  formValues: T
): T => ({
  ...formValues,
  automatedEmail: { ...formValues.automatedEmail },
});
